import { createAction } from '@reduxjs/toolkit';

const testType = createAction('qaTests/testType');

export default testType;